// PPC SKLP shared client logic - analytics, sticky CTA visibility, AJAX add-to-cart,
// drawer interaction, interactive concern filter, gclid/UTM persistence to cart attributes,
// first-party tracking passthrough to Klaviyo and Shopify analytics.
(function () {
  if (window.__ppcInit) return;
  window.__ppcInit = true;

  var ATTR_KEYS = ['gclid','wbraid','gbraid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','msclkid'];
  var TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 days, matches Google Ads attribution window

  // First-party tracking helpers (item 19)
  function trackKlaviyo(name, props) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', name, props || {}]);
    } catch (e) {}
  }
  function trackShopify(name, props) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, props || {});
      }
    } catch (e) {}
  }

  function emit(name, params) {
    var payload = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    trackKlaviyo(name, payload);
    trackShopify(name, payload);
  }

  // gclid/UTM persistence (item 2)
  function readURLAttrs() {
    try {
      var p = new URLSearchParams(window.location.search);
      var out = {};
      for (var i = 0; i < ATTR_KEYS.length; i++) {
        var v = p.get(ATTR_KEYS[i]);
        if (v) out[ATTR_KEYS[i]] = v;
      }
      return out;
    } catch (e) { return {}; }
  }
  function persistAttrs(attrs) {
    try {
      var keys = Object.keys(attrs);
      if (keys.length === 0) return;
      var record = { ts: Date.now(), attrs: attrs };
      window.localStorage.setItem('ppc_click_attrs', JSON.stringify(record));
    } catch (e) {}
  }
  function readStoredAttrs() {
    try {
      var raw = window.localStorage.getItem('ppc_click_attrs');
      if (!raw) return {};
      var record = JSON.parse(raw);
      if (!record || !record.ts || (Date.now() - record.ts) > TTL_MS) {
        window.localStorage.removeItem('ppc_click_attrs');
        return {};
      }
      return record.attrs || {};
    } catch (e) { return {}; }
  }
  function pushAttrsToCart(attrs) {
    var keys = Object.keys(attrs);
    if (keys.length === 0) return Promise.resolve();
    var body = { attributes: {} };
    keys.forEach(function (k) { body.attributes[k] = attrs[k]; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }
  function identifyKlaviyoFromAttrs(attrs) {
    try {
      var qp = new URLSearchParams(window.location.search);
      var email = qp.get('email') || qp.get('utm_email');
      if (email) {
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', { '$email': email }]);
      }
    } catch (e) {}
  }

  var freshAttrs = readURLAttrs();
  if (Object.keys(freshAttrs).length > 0) {
    persistAttrs(freshAttrs);
  }
  var storedAttrs = readStoredAttrs();
  if (Object.keys(storedAttrs).length > 0) {
    pushAttrsToCart(storedAttrs);
  }
  identifyKlaviyoFromAttrs(freshAttrs);

  emit('page_view', Object.assign({
    page_path: window.location.pathname,
    page_template: document.body.getAttribute('data-ppc-cluster') || ''
  }, freshAttrs));

  var fired50 = false;
  function onScroll() {
    if (fired50) return;
    var h = document.documentElement;
    var scrolled = (h.scrollTop + window.innerHeight) / h.scrollHeight;
    if (scrolled > 0.5) {
      fired50 = true;
      emit('scroll_50');
      window.removeEventListener('scroll', onScroll);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  var rec = document.querySelector('.ppc-block-product-rec, .ppc-block-comparison');
  if (rec && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          emit('view_item', { item_id: rec.getAttribute('data-product-handle') || 'comparison' });
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });
    io.observe(rec);
  }

  document.querySelectorAll('a.ppc-btn, a.ppc-sticky-cta__btn, a.ppc-header__cta').forEach(function (el) {
    el.addEventListener('click', function () {
      emit('select_item', { cta_label: el.textContent.trim(), cta_href: el.getAttribute('href') || '' });
    });
  });

  // Concern filter (option B - interactive)
  var filterGroup = document.querySelector('[data-ppc-concern-filter]');
  var concernTiles = document.querySelectorAll('[data-ppc-concern]');
  if (filterGroup && concernTiles.length > 0) {
    filterGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-filter]');
      if (!btn) return;
      var filter = btn.getAttribute('data-filter');
      filterGroup.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      concernTiles.forEach(function (tile) {
        var device = tile.getAttribute('data-device') || '';
        var show = filter === 'all' || device === filter;
        if (show) { tile.removeAttribute('hidden'); } else { tile.setAttribute('hidden', ''); }
      });
      emit('filter_concern', { filter: filter });
    });
  }

  // Add-to-cart + drawer
  var drawer = document.querySelector('[data-ppc-drawer]');
  var drawerBody = drawer && drawer.querySelector('[data-ppc-drawer-body]');
  var drawerTotal = drawer && drawer.querySelector('[data-ppc-drawer-total]');
  var cartCount = document.querySelector('[data-ppc-cart-count]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 350);
  }
  if (drawer) {
    drawer.querySelectorAll('[data-ppc-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return '£' + amount;
  }

  function renderCart(cart) {
    if (!drawerBody || !cart) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<p class="ppc-drawer__loading">Your bag is empty.</p>';
    } else {
      drawerBody.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title || '') + '" width="80" height="80" loading="lazy">' : '<span></span>';
        return '<div class="ppc-drawer__item">' + img +
          '<div><p class="ppc-drawer__item-title">' + escapeHtml(item.product_title || '') + '</p>' +
          '<p class="ppc-drawer__item-meta">Quantity ' + item.quantity + ' &middot; ' + money(item.final_line_price) + '</p></div></div>';
      }).join('');
    }
    if (drawerTotal) drawerTotal.textContent = money(cart.total_price || 0);
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      if (cart.item_count > 0) { cartCount.removeAttribute('hidden'); } else { cartCount.setAttribute('hidden', ''); }
    }
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  function addToCart(form) {
    var btn = form.querySelector('[data-ppc-atc-button]');
    var productTitle = btn ? btn.getAttribute('data-product-title') : '';
    var productPrice = btn ? btn.getAttribute('data-product-price') : '';
    var fd = new FormData(form);
    // Item 2: attach stored click attrs to the cart-add request so the order carries gclid/UTM for offline conversion import
    var attrsNow = readStoredAttrs();
    Object.keys(attrsNow).forEach(function (k) { fd.append('attributes[' + k + ']', attrsNow[k]); });
    if (btn) btn.disabled = true;
    openDrawer();
    if (drawerBody) drawerBody.innerHTML = '<p class="ppc-drawer__loading">Adding to bag</p>';

    emit('add_to_cart', { item_name: productTitle, item_price: productPrice, attribution: attrsNow });

    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (drawerBody) drawerBody.innerHTML = '<p class="ppc-drawer__loading">' + escapeHtml((res.json && res.json.description) || 'Sorry, that variant is unavailable.') + '</p>';
          return;
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
      })
      .catch(function () {
        if (drawerBody) drawerBody.innerHTML = '<p class="ppc-drawer__loading">Unable to update bag. Please try again.</p>';
      })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  document.querySelectorAll('[data-ppc-atc]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form);
    });
  });
})();
